import { useCallback, useRef, useState } from "react";

/**
 * Estado do modal de grade (GridModal): item ativo, quantidades temporárias e
 * filtros em massa. A condição de pagamento não é gerenciada aqui — a grade só
 * simula preço (estado próprio e local do GridModal); a condição real é
 * escolhida no carrinho, por vitrine.
 */
export default function useGridModalState({ orderState, setOrderState }) {
  const [activeFamilyKey, setActiveFamilyKey] = useState(null);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [tempGridState, setTempGridState] = useState({});
  const [selectedBulkAgrupadores, setSelectedBulkAgrupadores] = useState(
    new Set(),
  );
  const [selectedBulkSizes, setSelectedBulkSizes] = useState(new Set());

  // Refs espelhando o estado mais recente: permitem que os callbacks abaixo tenham
  // deps [] e identidade permanentemente estável. Se openGridModal dependesse de
  // `orderState`, sua identidade mudaria a cada tecla digitada numa quantidade,
  // quebrando o memo de TODOS os cards de grade (que o recebem como prop).
  const orderStateRef = useRef(orderState);
  orderStateRef.current = orderState;
  const tempGridStateRef = useRef(tempGridState);
  tempGridStateRef.current = tempGridState;

  const openGridModal = useCallback((familyKey) => {
    setActiveFamilyKey(familyKey);
    setTempGridState({ ...orderStateRef.current });
    setSelectedBulkAgrupadores(new Set());
    setSelectedBulkSizes(new Set());
    setGridModalOpen(true);
  }, []);

  const closeGridModal = useCallback(() => {
    setGridModalOpen(false);
    setActiveFamilyKey(null);
    setTempGridState({});
  }, []);

  const saveGridSelection = useCallback(
    (gridState) => {
      setOrderState({ ...(gridState ?? tempGridStateRef.current) });
      closeGridModal();
    },
    [setOrderState, closeGridModal],
  );

  const toggleBulkSelection = useCallback((type, value) => {
    const applyToggle = (prev) => {
      const newSet = new Set(prev);
      if (newSet.has(value)) newSet.delete(value);
      else newSet.add(value);
      return newSet;
    };
    if (type === "size") {
      setSelectedBulkSizes(applyToggle);
    } else if (type === "agrupador") {
      setSelectedBulkAgrupadores(applyToggle);
    }
  }, []);

  return {
    activeFamilyKey,
    gridModalOpen,
    tempGridState,
    setTempGridState,
    selectedBulkAgrupadores,
    selectedBulkSizes,
    openGridModal,
    closeGridModal,
    saveGridSelection,
    toggleBulkSelection,
  };
}
